import { HashRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Services from './components/Services';
import AirportTransfers from './components/AirportTransfers';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ServiceDetail from './pages/ServiceDetail';
import AirportDetail from './pages/AirportDetail';
import ScrollToTop from './components/ScrollToTop';

function HomePage() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Services />
      <AirportTransfers />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/service-details/:slug" element={<ServiceDetail />} />
        <Route path="/airport-details/:slug" element={<AirportDetail />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
